(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const R = window.vlRoutes || {};
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const box = (type) => ({ get(k) { try { return window[type].getItem(k); } catch (e) { return null; } }, set(k, v) { try { window[type].setItem(k, v); } catch (e) {} } });
  const store = box('localStorage');
  const sess = box('sessionStorage');
  const ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;' };
  ESC[String.fromCharCode(34)] = '&quot;';
  ESC[String.fromCharCode(39)] = '&#39;';
  const ESC_RE = new RegExp('[&<>' + String.fromCharCode(34, 39) + ']', 'g');
  const esc = (s) => String(s == null ? '' : s).replace(ESC_RE, (c) => ESC[c]);
  const sized = (url, w) => { if (!url) return ''; try { const u = new URL(url, location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; } };
  const money = (cents, trim) => {
    const fmt = String(R.money || '${{amount}}').replace(/<[^>]*>/g, '');
    const n = Number(cents || 0) / 100;
    const fmtN = (d, comma) => { let s = n.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d }); if (comma) s = s.replace(/,/g, '_').replace(/[.]/g, ',').replace(/_/g, '.'); return s; };
    const map = { amount: () => fmtN(2), amount_no_decimals: () => fmtN(0), amount_with_comma_separator: () => fmtN(2, true), amount_no_decimals_with_comma_separator: () => fmtN(0, true) };
    let out = fmt.replace(/[{][{] *([a-z_]+) *[}][}]/, (m, k) => (map[k] || map.amount)());
    if (trim) out = out.replace(/[.,]00(?![0-9])/, '');
    return out;
  };
  const SVG = (d) => `<svg class='vl-i' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.8' stroke-linecap='round' aria-hidden='true'>${d}</svg>`;
  const PLUS = SVG(`<path d='M12 5v14M5 12h14'/>`);
  const MINUS = SVG(`<path d='M5 12h14'/>`);

  /* Announcement bar */
  $$('[data-vl-announce]').forEach((bar) => {
    const msgs = $$('.vl-announce__msg', bar);
    if (msgs.length < 2) return;
    let i = 0;
    setInterval(() => { if (document.hidden) return; msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, 4200);
  });

  /* Mobile menu */
  $$('.vl-menu').forEach((menu) => {
    menu.addEventListener('click', (e) => { if (e.target.closest('a')) menu.open = false; });
    document.addEventListener('click', (e) => { if (menu.open && !menu.contains(e.target)) menu.open = false; });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && menu.open) { menu.open = false; $('summary', menu).focus(); } });
  });

  /* Cart drawer */
  const drawer = $('[data-vl-cart]');
  const overlay = $('[data-vl-overlay]');
  let lastFocus = null;
  let closeTimer = null;
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  const Cart = {
    async get() { const r = await fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }); return r.json(); },
    async add(id, qty) {
      const r = await post(R.cartAdd + '.js', { items: [{ id: Number(id), quantity: Number(qty) || 1 }] });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || 'This lamp could not be added to your cart.');
      return j;
    },
    async change(line, quantity) { const r = await post(R.cartChange + '.js', { line, quantity }); return r.json(); },
    render(c) {
      $$('[data-vl-cart-count]').forEach((el) => { el.textContent = c.item_count; el.hidden = !c.item_count; });
      if (!drawer) return;
      const body = $('[data-vl-cart-items]', drawer);
      const foot = $('[data-vl-cart-foot]', drawer);
      const up = $('[data-vl-upsell]', drawer);
      if (!c.item_count) {
        body.innerHTML = `<div class='vl-empty'><p>Your cart is empty.</p><a class='vl-btn vl-btn--ember' href='${esc(R.product || R.root)}'>Shop the lamp</a></div>`;
        foot.hidden = true;
        if (up) up.hidden = true;
        return;
      }
      foot.hidden = false;
      body.innerHTML = c.items.map((it, i) => {
        const img = it.image ? `<img class='vl-line__img' src='${esc(sized(it.image, 200))}' alt='' width='76' height='76' loading='lazy'>` : `<span class='vl-line__img'></span>`;
        const variant = it.variant_title && !/default title/i.test(it.variant_title) ? `<div class='vl-line__v'>${esc(it.variant_title)}</div>` : '';
        const discs = (it.line_level_discount_allocations || []).map((d) => `<div class='vl-line__disc'>${esc(d.discount_application && d.discount_application.title)}</div>`).join('');
        const was = it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : '';
        return `<div class='vl-line'>${img}<div><a class='vl-line__t' href='${esc(it.url)}'>${esc(it.product_title)}</a>${variant}${discs}<div class='vl-qty'><button type='button' data-line='${i + 1}' data-q='${it.quantity - 1}' aria-label='Remove one'>${MINUS}</button><span>${it.quantity}</span><button type='button' data-line='${i + 1}' data-q='${it.quantity + 1}' aria-label='Add one'>${PLUS}</button></div></div><div class='vl-line__p'>${was}<span>${money(it.final_line_price)}</span></div></div>`;
      }).join('');
      const discRow = $('[data-vl-disc-row]', drawer);
      if (discRow) { discRow.hidden = !c.total_discount; $('[data-vl-disc]', drawer).textContent = '-' + money(c.total_discount); }
      $('[data-vl-cart-total]', drawer).textContent = money(c.total_price);
      if (up) {
        const mine = c.items.filter((it) => String(it.product_id) === String(R.lampId));
        const count = mine.reduce((n, it) => n + it.quantity, 0);
        up.hidden = !(mine.length && count === 1);
        if (mine.length) up.dataset.variant = mine[0].variant_id;
      }
    },
    async refresh() { const c = await this.get(); this.render(c); return c; },
    open() {
      if (!drawer) return;
      clearTimeout(closeTimer);
      lastFocus = document.activeElement;
      overlay.hidden = false;
      drawer.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => { overlay.classList.add('is-open'); drawer.classList.add('is-open'); }));
      document.documentElement.classList.add('vl-lock');
      const x = $('[data-vl-close]', drawer);
      if (x) x.focus();
    },
    close() {
      if (!drawer || drawer.hidden) return;
      overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('vl-lock');
      closeTimer = setTimeout(() => { drawer.hidden = true; overlay.hidden = true; }, 360);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    },
    isOpen() { return Boolean(drawer && !drawer.hidden); }
  };
  window.vlCart = Cart;
  const addAndOpen = async (id, qty) => { await Cart.add(id, qty); if (drawer) { await Cart.refresh(); Cart.open(); } else { location.href = R.cart; } };

  $$('[data-vl-cart-open]').forEach((link) => link.addEventListener('click', async (e) => {
    if (!drawer) return;
    e.preventDefault();
    Cart.open();
    try { await Cart.refresh(); } catch (err) { location.href = link.href; }
  }));
  if (overlay) overlay.addEventListener('click', () => Cart.close());
  if (drawer) {
    const x = $('[data-vl-close]', drawer);
    if (x) x.addEventListener('click', () => Cart.close());
    drawer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { Cart.close(); return; }
      if (e.key !== 'Tab') return;
      const items = $$('a[href], button:not([disabled]), input, select, textarea', drawer).filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    $('[data-vl-cart-items]', drawer).addEventListener('click', async (e) => {
      const b = e.target.closest('[data-line]');
      if (!b) return;
      b.disabled = true;
      try { Cart.render(await Cart.change(Number(b.dataset.line), Math.max(0, Number(b.dataset.q)))); } catch (err) { b.disabled = false; }
    });
    const upBtn = $('[data-vl-upsell-add]', drawer);
    if (upBtn) upBtn.addEventListener('click', async () => {
      const up = $('[data-vl-upsell]', drawer);
      if (!up || !up.dataset.variant) return;
      upBtn.disabled = true;
      try { await Cart.add(up.dataset.variant, 1); await Cart.refresh(); } catch (err) { /* keep the drawer as it is */ } finally { upBtn.disabled = false; }
    });
  }

  /* Product forms */
  $$('[data-vl-product]').forEach((root) => {
    let data;
    try { data = JSON.parse($('[data-vl-product-json]', root).textContent); } catch (e) { return; }
    const form = $('form', root);
    if (!form) return;
    const scope = root.closest('[data-vl-scope]') || root;
    const idInput = $('input[name=id]', form);
    const btn = $('[data-vl-add]', form);
    const label = $('[data-vl-btn-label]', btn);
    const btnPrice = $('[data-vl-btn-price]', btn);
    const status = $('[data-vl-status]', form);
    const priceEls = $$('[data-vl-price]', scope);
    const tiers = $$('[data-vl-tiers] input', form);
    const opts = $$('[data-vl-option]', form);
    const pct = Number(root.dataset.bundlePct || 0);
    const pick = () => {
      if (!opts.length) return data.variants.find((v) => String(v.id) === String(idInput.value)) || data.variants[0];
      const vals = opts.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
      return data.variants.find((v) => v.options.every((o, i) => o === vals[i]));
    };
    const qty = () => { const t = tiers.find((x) => x.checked); return t ? Number(t.value) : 1; };
    const total = (v, q) => (q >= 2 && pct ? Math.round((v.price * q * (100 - pct)) / 100) : v.price * q);
    const update = (sync) => {
      opts.forEach((fs) => { const c = $('input:checked', fs); const out = $('[data-vl-option-value]', fs); if (c && out) out.textContent = c.value; });
      const v = pick();
      if (!v) { btn.disabled = true; label.textContent = 'Unavailable'; if (btnPrice) btnPrice.textContent = ''; return; }
      idInput.value = v.id;
      priceEls.forEach((el) => { el.textContent = money(v.price, true); });
      tiers.forEach((t) => { const p = $('[data-vl-tier-price]', t.closest('.vl-tier')); if (p) p.textContent = money(total(v, Number(t.value)), true); });
      btn.disabled = !v.available;
      label.textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
      if (btnPrice) btnPrice.textContent = v.available ? money(total(v, qty()), true) : '';
      document.dispatchEvent(new CustomEvent('vl:variant', { detail: { variant: v, qty: qty(), total: total(v, qty()) } }));
      if (sync && root.hasAttribute('data-vl-url')) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); }
    };
    form.addEventListener('change', (e) => { if (status) status.textContent = ''; update(Boolean(e.target.closest('[data-vl-option]'))); });
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      label.textContent = 'Adding';
      if (status) status.textContent = '';
      try { await addAndOpen(idInput.value, qty()); } catch (err) { if (status) status.textContent = err.message; } finally { btn.disabled = false; update(false); }
    });
    update(false);
  });

  /* One-click add forms */
  $$('[data-vl-quick-form]').forEach((f) => f.addEventListener('submit', async (e) => {
    e.preventDefault();
    const b = $('button[type=submit]', f);
    if (b) b.disabled = true;
    try { await addAndOpen($('input[name=id]', f).value, 1); } catch (err) { f.submit(); } finally { if (b) b.disabled = false; }
  }));

  /* Gallery */
  $$('[data-vl-gallery]').forEach((g) => {
    const track = $('[data-vl-gal-track]', g);
    if (!track) return;
    const slides = $$('.vl-gal__slide', track);
    const thumbs = $$('[data-vl-thumb]', g);
    const count = $('[data-vl-gal-count]', g);
    const prev = $('[data-vl-gal-prev]', g);
    const next = $('[data-vl-gal-next]', g);
    let cur = -1;
    const go = (i) => { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); };
    const mark = (i) => {
      cur = i;
      thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      const t = thumbs[i];
      const list = t && t.parentElement;
      if (list && list.scrollWidth > list.clientWidth) list.scrollTo({ left: t.offsetLeft - list.offsetLeft - 16, behavior: reduce ? 'auto' : 'smooth' });
    };
    let raf = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i !== cur) mark(i); }); }, { passive: true });
    thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
    if (prev) prev.addEventListener('click', () => go(cur - 1));
    if (next) next.addEventListener('click', () => go(cur + 1));
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); } });
    mark(0);
  });

  /* Delivery estimate */
  const addBiz = (n) => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) k += 1; } return d; };
  const fmtDay = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  $$('[data-vl-eta]').forEach((el) => {
    const min = Number(el.dataset.min) || 5;
    const max = Number(el.dataset.max) || 9;
    const out = $('[data-vl-eta-range]', el);
    if (out) out.textContent = 'between ' + fmtDay.format(addBiz(min)) + ' and ' + fmtDay.format(addBiz(max));
  });

  /* Light switch section */
  $$('[data-vl-switch]').forEach((sec) => {
    const btn = $('[data-vl-toggle]', sec);
    const label = $('[data-vl-toggle-label]', sec);
    if (!btn) return;
    const set = (on, flick) => {
      sec.dataset.state = on ? 'on' : 'off';
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      if (label) label.textContent = on ? btn.dataset.on : btn.dataset.off;
      $$('.vl-switch__h', sec).forEach((h) => h.setAttribute('aria-hidden', h.classList.contains(on ? 'vl-switch__h--on' : 'vl-switch__h--off') ? 'false' : 'true'));
      if (flick && on && !reduce) { sec.classList.remove('is-flicker'); void sec.offsetWidth; sec.classList.add('is-flicker'); }
    };
    btn.addEventListener('click', () => set(sec.dataset.state !== 'on', true));
    if (reduce || !('IntersectionObserver' in window)) return;
    if (sec.getBoundingClientRect().top > window.innerHeight) {
      set(false, false);
      const io = new IntersectionObserver((entries) => {
        if (!entries.some((en) => en.isIntersecting)) return;
        io.disconnect();
        setTimeout(() => set(true, true), 650);
      }, { threshold: 0.35 });
      io.observe(sec);
    }
  });

  /* Sticky add to cart */
  const sticky = $('[data-vl-sticky]');
  const anchor = $('.vl-buy [data-vl-add]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    const sbtn = $('[data-vl-sticky-add]', sticky);
    const sio = new IntersectionObserver(([en]) => {
      const show = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (sbtn) sbtn.tabIndex = show ? 0 : -1;
      document.documentElement.classList.toggle('vl-has-sticky', show);
    });
    sio.observe(anchor);
    document.addEventListener('vl:variant', (e) => { const p = $('[data-vl-sticky-price]', sticky); if (p) p.textContent = (e.detail.qty > 1 ? e.detail.qty + ' lamps, ' : '') + money(e.detail.total, true); });
    if (sbtn) sbtn.addEventListener('click', () => { const f = anchor.closest('form'); if (f && f.requestSubmit) f.requestSubmit(); else anchor.click(); });
  }

  /* Recent real orders (filled from Shopify orders, never invented) */
  const pop = $('[data-vl-pop]');
  const popData = document.getElementById('vl-orders');
  if (pop && popData && !sess.get('vl-pop-off')) {
    let list = [];
    try { list = JSON.parse(popData.textContent); } catch (e) { list = []; }
    const now = Date.now();
    list = (Array.isArray(list) ? list : []).filter((o) => o && o.city && o.at && now - Date.parse(o.at) >= 0 && now - Date.parse(o.at) < 7 * 864e5).sort((a, b) => Date.parse(b.at) - Date.parse(a.at)).slice(0, 5);
    if (list.length) {
      const ago = (t) => { const m = Math.round((Date.now() - Date.parse(t)) / 60000); if (m < 2) return 'Just now'; if (m < 60) return m + ' minutes ago'; const h = Math.round(m / 60); if (h < 24) return h === 1 ? '1 hour ago' : h + ' hours ago'; const d = Math.round(h / 24); return d === 1 ? 'Yesterday' : d + ' days ago'; };
      const tEl = $('[data-vl-pop-t]', pop);
      const sEl = $('[data-vl-pop-s]', pop);
      let i = 0;
      let timer = null;
      const show = () => {
        if (Cart.isOpen()) { timer = setTimeout(show, 8000); return; }
        const o = list[i];
        i += 1;
        tEl.textContent = 'Someone in ' + o.city + (o.region ? ', ' + o.region : '') + ' ordered ' + (o.product || 'The Velira Lamp');
        sEl.textContent = ago(o.at);
        pop.hidden = false;
        requestAnimationFrame(() => requestAnimationFrame(() => pop.classList.add('is-on')));
        timer = setTimeout(hide, 6500);
      };
      const hide = () => { pop.classList.remove('is-on'); setTimeout(() => { pop.hidden = true; }, 400); if (i < list.length) timer = setTimeout(show, 20000 + Math.random() * 15000); };
      $('[data-vl-pop-x]', pop).addEventListener('click', () => { clearTimeout(timer); pop.classList.remove('is-on'); pop.hidden = true; sess.set('vl-pop-off', '1'); });
      timer = setTimeout(show, 10000);
    }
  }

  /* Email offer */
  const modal = $('[data-vl-email]');
  if (modal) {
    const KEY = 'vl-email-seen';
    const success = Boolean($('[data-vl-email-success]', modal));
    const failed = Boolean($('[data-vl-email-error]', modal));
    let opened = false;
    let mfocus = null;
    const open = () => {
      if (opened) return;
      if (Cart.isOpen()) { setTimeout(open, 8000); return; }
      opened = true;
      mfocus = document.activeElement;
      modal.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => modal.classList.add('is-open')));
      document.documentElement.classList.add('vl-lock');
      const f = $('[data-vl-copy], input[type=email]', modal);
      if (f) f.focus();
      store.set(KEY, String(Date.now()));
    };
    const close = () => {
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('vl-lock');
      setTimeout(() => { modal.hidden = true; }, 300);
      if (mfocus && mfocus.focus) mfocus.focus();
    };
    $$('[data-vl-email-x]', modal).forEach((b) => b.addEventListener('click', close));
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
    modal.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    const copy = $('[data-vl-copy]', modal);
    if (copy) copy.addEventListener('click', async () => { const s = $('[data-vl-copy-status]', modal); try { await navigator.clipboard.writeText(copy.dataset.vlCopy); if (s) s.textContent = 'Copied. Paste it at checkout.'; } catch (e) { if (s) s.textContent = 'Select the code to copy it.'; } });
    if (success || failed) { open(); }
    else if (Date.now() - Number(store.get(KEY) || 0) > 5 * 864e5) {
      const t = setTimeout(open, (Number(modal.dataset.delay) || 12) * 1000);
      const exit = (e) => { if (!e.relatedTarget && e.clientY < 8) { clearTimeout(t); document.removeEventListener('mouseout', exit); open(); } };
      document.addEventListener('mouseout', exit);
    }
  }
})();
